"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var ChatPage_1;
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const ChatStateService_1 = __importStar(require("@front/services/chat/ChatStateService"));
const backendImport_1 = require("@front/backendImport");
const IAvatar_1 = __importDefault(require("@back/models/interfaces/IAvatar"));
const client_1 = require("@rws-framework/client");
const models_types_1 = require("../../../types/models.types");
const backdrop_observer_helper_1 = require("@front/helpers/backdrop-observer.helper");
const voices_helper_1 = require("@front/helpers/voices.helper");
const ChatEventsHelper_1 = require("./helpers/ChatEventsHelper");
const ChatSignalHelper_1 = require("./helpers/ChatSignalHelper");
const theAiProvider = 'openrouter';
//@ts-ignore                
let rwsTemplate = T.html `<div id="ai-chat" style="--chat-height: ${x => x.chatHeight ? x.chatHeight + 'px' : 'auto'};">
    <div class="chat-layout">           
        <div class="chat-main">                        
            <app-chat 
                :knowledge="${x => x.selectedKnowledge}"                 :fullKnowledgeIds="${x => x.fullKnowledgeIds}"                :selectedAvatar="${x => x.selectedAvatar}" 
                :selectedAIProvider="${x => x.selectedAIProvider}" 
                :selectedModel="${x => ({ model: x.selectedModel, provider: x.selectedProvider, aiProvider: x.selectedAIProvider })}"
                :injectedMessages="${x => x.injectedMessages}"
                :conversationId="${x => { var _a; return (_a = x.selectedConversation) === null || _a === void 0 ? void 0 : _a.id; }}"
                :conversationUid="${x => { var _a; return (_a = x.selectedConversation) === null || _a === void 0 ? void 0 : _a.uid; }}"
                :webSearchEnabled="${x => x.webSearchEnabled}"
                :deepSearchEnabled="${x => x.deepSearchEnabled}"
                :canTalk="${x => x.canTalk}"
                :fullscan="${x => x.fullscan}"
                @modelSynced="${(x, c) => x.onModelSynced(c.event)}"
                @kdbPick="${(x, c) => x.kdbPick(c.event)}">
            </app-chat>            
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `#ai-chat {
  height: var(--chat-height, auto);
  display: flex;
  flex-direction: column;
}
#ai-chat .chat-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
}
#ai-chat .chat-layout conversation-list {
  flex-shrink: 0;
}
#ai-chat .chat-layout .chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
#ai-chat .chat-layout .chat-main .conversation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  margin-bottom: 16px;
  border-radius: 8px 8px 0 0;
  flex-shrink: 0;
}
#ai-chat .chat-layout .chat-main .conversation-header .conversation-title {
  margin: 0;
  font-size: 2vw;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 16px;
}
@media (max-width: 768px) {
  #ai-chat .chat-layout .chat-main .conversation-header .conversation-title {
    font-size: 3.5vw;
  }
}
#ai-chat .chat-layout .chat-main .conversation-header .sync-model-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}
#ai-chat .chat-layout .chat-main .conversation-header .sync-model-btn:hover {
  background-color: #0056b3;
}
#ai-chat .chat-layout .chat-main .conversation-header .sync-model-btn:active {
  background-color: #004494;
}
#ai-chat .chat-layout .chat-main .conversation-header .sync-model-btn i {
  font-size: 12px;
}
#ai-chat .chat-layout .chat-main app-chat {
  flex: 1;
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media (max-width: 768px) {
  #ai-chat .chat-layout {
    flex-direction: column;
  }
  #ai-chat .chat-layout conversation-list {
    order: 2;
  }
  #ai-chat .chat-layout .chat-main {
    order: 1;
    flex: 1;
  }
  #ai-chat .chat-layout .chat-main .conversation-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  #ai-chat .chat-layout .chat-main .conversation-header .conversation-title {
    margin-right: 0;
    margin-bottom: 0;
    font-size: 4vw;
  }
  #ai-chat .chat-layout .chat-main .conversation-header .sync-model-btn {
    align-self: flex-end;
  }
}
#knowledge-container {
  padding: 20px;
}`;
const shadowOptions = { "mode": "open" };
let ChatPage = ChatPage_1 = class ChatPage extends client_1.RWSViewComponent {
    constructor(storageService, signalService, chatStateService) {
        super();
        this.storageService = storageService;
        this.signalService = signalService;
        this.chatStateService = chatStateService;
        this.selectedAIProvider = theAiProvider;
        this.selectedConversation = null;
        this.injectedMessages = [];
        this.selectedKnowledge = [];
        this.fullKnowledgeIds = [];
        this.webSearchEnabled = false;
        this.deepSearchEnabled = false;
        this.fullscan = false;
        this.hasBackdrop = false;
        this.canTalk = false;
        this.signalSubscriptions = [];
        this.chatHeight = window.innerHeight - ChatPage_1.layoutPaddings;
    }
    async connectedCallback() {
        super.connectedCallback();
        ChatSignalHelper_1.ChatSignalHelper.workWithSignals.bind(this)();
        // Initialize from current signal values
        const currentConversation = this.conversationSignal.getValue();
        const currentModel = this.modelSignal.getValue();
        if (currentConversation) {
            this.handleConversationChange(currentConversation.conversation, currentConversation.frontMessages);
        }
        // if (currentModel && (currentModel.model || currentModel.avatar)) {
        //     this.handleModelChange(currentModel);
        // } else {
        //     // Try to load saved model data and update signal
        // }
        this.loadSavedModelData();
        this.backdropSubscriberId = backdrop_observer_helper_1.BackdropObserverHelper.subscribe((hasBackdrop) => {
            this.hasBackdrop = hasBackdrop;
        }, this.shadowRoot);
        if (this.storageService.get('ai.webSearchEnabled') === 'true') {
            this.webSearchEnabled = true;
        }
        if (this.storageService.get('ai.deepSearchEnabled') === 'true') {
            this.deepSearchEnabled = true;
        }
        ChatEventsHelper_1.ChatEventsHelper.setEvents.bind(this)();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up signal subscriptions
        this.signalSubscriptions.forEach((sub, index) => {
            if (!sub.closed) {
                sub.unsubscribe();
            }
        });
        this.signalSubscriptions = [];
        if (this.backdropSubscriberId) {
            backdrop_observer_helper_1.BackdropObserverHelper.unsubscribe(this.backdropSubscriberId);
            this.backdropSubscriberId = undefined;
        }
        this.navBarSignal.setValue({ showChatControls: false });
    }
    /**
     * Handle conversation changes from signal
     */
    handleConversationChange(conversation, frontMessages, isNew = true) {
        var _a;
        const currentAvatar = this.selectedAvatarId;
        this.selectedConversation = conversation;
        const chatComponent = this.$('app-chat');
        if (chatComponent && chatComponent.setConversationData) {
            chatComponent.setConversationData(conversation, frontMessages, isNew);
            if (conversation === null) {
                this.injectedMessages = [];
            }
            // Preserve avatar selection if conversation doesn't have one or if we want to keep current selection
            if (currentAvatar && conversation && (!((_a = conversation.model) === null || _a === void 0 ? void 0 : _a.avatar) || currentAvatar !== conversation.model.avatar)) {
                chatComponent.selectedAvatar = this.selectedAvatar;
                this.selectedAvatarId = currentAvatar;
            }
        }
    }
    /**
     * Handle model changes from signal
     */
    async handleModelChange(selectedModel) {
        console.log('Handling model change:');
        console.trace(selectedModel);
        // Save model choices to localStorage
        this.saveModelToStorage(selectedModel);
        // Update local properties first
        this.selectedModel = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.model) || null;
        this.selectedAIProvider = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.aiProvider) || 'openrouter';
        this.selectedAvatarId = selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.avatar;
        this.canTalk = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.canTalk) || false;
        const chatComponent = this.$('app-chat');
        if (chatComponent) {
            // Always set the basic model data
            // Load avatar data if avatar is selected
            if (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.avatar) {
                await this.loadAvatarData(selectedModel.avatar);
                // Avatar will be set in loadAvatarData method
            }
            else {
                // Clear avatar if none selected                
                this.selectedModel = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.model) || null;
                this.selectedAvatar = undefined;
            }
            chatComponent.setModelData(selectedModel);
        }
    }
    shouldUpdateModel(selectedModel) {
        var _a;
        if (!this.selectedModel) {
            return true;
        }
        const modelValueChanged = this.selectedModel.value !== ((_a = selectedModel.model) === null || _a === void 0 ? void 0 : _a.value);
        const avatarChanged = this.selectedAvatarId !== selectedModel.avatar;
        const shouldUpdate = modelValueChanged || avatarChanged;
        return shouldUpdate;
    }
    selectedModelChanged(oldVal, newVal) {
        if (newVal && oldVal !== newVal) {
            this.canTalk = (0, voices_helper_1.isModelInElevenLabs)(newVal.value);
        }
    }
    kdbPick(event) {
        var _a, _b;
        this.selectedKnowledge = ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.selectedIds) || [];
        this.fullKnowledgeIds = ((_b = event.detail) === null || _b === void 0 ? void 0 : _b.fullKnowledgeIds) || [];
    }
    onConversationSelected(event) {
        const { conversation, messages } = event.detail;
        // Update the signal with both conversation and messages
        this.conversationSignal.setValue({
            conversation,
            frontMessages: messages || [],
            isNew: false
        });
    }
    async getConvo(id) {
        try {
            const response = await this.apiService.back.get('conversation.get', { routeParams: { id } });
            if (response && response.success && response.data) {
                const convo = response.data;
                this.conversationSignal.setValue({ conversation: convo, frontMessages: [], isNew: true });
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'chat.failedToLoadConversation'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('chat.failedToLoadConversation'.t(), 'error');
        }
    }
    onModelSynced(event) {
        const { model } = event.detail;
        // Create a selected model object and update the signal
        if (model) {
            const selectedModel = {
                model: model.model,
                provider: model.provider,
                aiProvider: theAiProvider, //model.aiProvider,
                avatar: model.avatar,
                avatarProvider: model.avatarProvider
            };
            // Update the signal instead of local state
            this.modelSignal.setValue(selectedModel);
        }
    }
    /**
     * Load full avatar data from avatar ID
     */
    async loadAvatarData(avatarId) {
        var _a;
        try {
            const avatarResponse = await this.apiService.back.get('avatar.get', {
                routeParams: { id: avatarId }
            });
            this.selectedAvatar = avatarResponse.data;
            this.canTalk = ((_a = this.selectedAvatar) === null || _a === void 0 ? void 0 : _a.isVoiceAgent) || false;
        }
        catch (error) {
            this.selectedAvatar = undefined;
        }
    }
    /**
     * Check if conversation model differs from selected model
     */
    hasModelMismatch() {
        var _a;
        const currentModel = this.modelSignal.getValue();
        const currentConversation = this.conversationSignal.getValue();
        if (!(currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.conversation.model) || !currentModel) {
            return false;
        }
        return currentConversation.conversation.model.model.value !== ((_a = currentModel.model) === null || _a === void 0 ? void 0 : _a.value) ||
            currentConversation.conversation.model.aiProvider !== currentModel.aiProvider ||
            currentConversation.conversation.model.avatar !== currentModel.avatar;
    }
    /**
     * Sync conversation model to currently selected model
     */
    syncToConversationModel() {
        const currentConversation = this.conversationSignal.getValue();
        if (currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.conversation.model) {
            const selectedModel = {
                model: currentConversation.conversation.model.model,
                provider: currentConversation.conversation.model.provider,
                aiProvider: theAiProvider, //currentConversation.conversation.model.aiProvider,
                avatar: currentConversation.conversation.model.avatar
            };
            // Update the signal instead of local state
            this.modelSignal.setValue(selectedModel);
        }
    }
    /**
     * Load saved model data from localStorage and send signal if available
     */
    loadSavedModelData() {
        const savedAIProvider = theAiProvider;
        const savedProvider = this.storageService.get('ai.selectedProvider');
        const savedModel = this.storageService.get('ai.selectedModel');
        const savedAvatar = this.storageService.get('ai.selectedAvatar');
        console.log({ savedAvatar });
        // Handle avatar-only selection (from onboarding)
        if (savedAvatar && savedAvatar !== 'null' && savedAvatar !== 'undefined') {
            // Load the avatar and get its model data
            this.loadAvatarData(savedAvatar).then(() => {
                if (this.selectedAvatar && this.selectedAvatar.model) {
                    // Create selected model from avatar data
                    const selectedModel = {
                        aiProvider: theAiProvider,
                        provider: this.selectedAvatar.model.provider,
                        model: this.selectedAvatar.model.model,
                        avatar: savedAvatar,
                        avatarProvider: theAiProvider,
                        canTalk: this.selectedAvatar.isVoiceAgent || false
                    };
                    // Update local properties
                    this.selectedAIProvider = selectedModel.aiProvider;
                    this.selectedModel = selectedModel.model;
                    this.selectedAvatarId = selectedModel.avatar;
                    // Update the signal
                    this.modelSignal.setValue(selectedModel);
                }
                else {
                    console.error('Failed to load avatar data for saved avatar ID:', savedAvatar);
                    this.setDefaultModel();
                }
            }).catch(error => {
                console.error('Error loading avatar data for saved avatar ID:', savedAvatar, error);
                this.setDefaultModel();
            });
            return;
        }
        else {
            console.log('No saved avatar found, clearing selected avatar from local state');
            this.selectedAvatar = undefined;
        }
        // Check if we have valid saved model data
        if (savedAIProvider && savedProvider && savedModel) {
            try {
                const provider = JSON.parse(savedProvider);
                const model = JSON.parse(savedModel);
                // Create the selected model object
                const selectedModel = {
                    aiProvider: theAiProvider,
                    provider: provider,
                    model: model,
                    avatar: undefined,
                    avatarProvider: undefined,
                    canTalk: false
                };
                // Update local properties first
                this.selectedAIProvider = theAiProvider; //selectedModel.aiProvider;
                this.selectedModel = selectedModel.model;
                this.selectedAvatarId = undefined;
                this.selectedAvatar = undefined;
                // Update the signal
                this.modelSignal.setValue(selectedModel);
            }
            catch (error) {
                // Error parsing saved model data
                // Set default model if parsing fails
                console.error('Error parsing saved model data, setting default model', error);
                this.setDefaultModel();
            }
        }
        else {
            // Set default model if no saved data
            console.log('No saved model data found, setting default model');
            this.setDefaultModel();
        }
    }
    /**
     * Set default model when no saved data is available
     */
    setDefaultModel() {
        const defaultModel = {
            model: { value: 'openai/gpt-5', label: 'GPT-5' },
            provider: { name: "OpenAI", value: "openai" },
            aiProvider: 'openrouter'
        };
        // Save to localStorage
        this.saveModelToStorage(defaultModel);
        // Send the signal
        this.modelSignal.setValue(defaultModel);
        console.trace(defaultModel);
    }
    /**
     * Save model selection to localStorage
     */
    saveModelToStorage(selectedModel) {
        if (!selectedModel) {
            console.log('Clearing model selection from storage (ChatPage - saveModelToStorage)');
            // Clear localStorage when model is null
            this.storageService.clear('ai.selectedProvider');
            this.storageService.clear('ai.selectedAIProvider');
            this.storageService.clear('ai.selectedModel');
            this.storageService.clear('ai.selectedAvatar');
            return;
        }
        // For avatar selections, provider might be undefined - that's OK
        if (selectedModel.avatar) {
            // Avatar selections are valid even without complete provider info
            this.storageService.set('ai.selectedAIProvider', theAiProvider);
            this.storageService.set('ai.selectedModel', JSON.stringify(selectedModel.model || {
                value: 'anthropic/claude-sonnet-4.5',
                label: 'Claude Sonnet 4.5'
            }));
            // Use provided provider or default for avatars
            const provider = selectedModel.provider || { name: "IntHub Avatar", value: "inthub" };
            this.storageService.set('ai.selectedProvider', JSON.stringify(provider));
            this.storageService.set('ai.selectedAvatar', String(selectedModel.avatar));
            return;
        }
        // For regular model selections, validate that we have complete data
        if (selectedModel.provider && selectedModel.aiProvider && selectedModel.model) {
            this.storageService.set('ai.selectedProvider', JSON.stringify(selectedModel.provider));
            this.storageService.set('ai.selectedAIProvider', theAiProvider); //selectedModel.aiProvider);
            this.storageService.set('ai.selectedModel', JSON.stringify(selectedModel.model));
            if (selectedModel.avatar) {
                this.storageService.set('ai.selectedAvatar', String(selectedModel.avatar));
            }
            else {
                console.log('Clearing selected avatar from storage (ChatPage - saveModelToStorage)', { selectedModel });
                this.storageService.clear('ai.selectedAvatar');
            }
        }
        else {
            // Model doesn't have all required fields, skip saving
        }
    }
};
exports.ChatPage = ChatPage;
ChatPage.layoutPaddings = 80;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _d : Object)
], ChatPage.prototype, "selectedAIProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof backendImport_1.IProvider !== "undefined" && backendImport_1.IProvider) === "function" ? _e : Object)
], ChatPage.prototype, "selectedProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof backendImport_1.IProvidedModel !== "undefined" && backendImport_1.IProvidedModel) === "function" ? _f : Object)
], ChatPage.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ChatPage.prototype, "selectedAvatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof IAvatar_1.default !== "undefined" && IAvatar_1.default) === "function" ? _g : Object)
], ChatPage.prototype, "selectedAvatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _h : Object)
], ChatPage.prototype, "selectedConversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatPage.prototype, "injectedMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ChatPage.prototype, "avatarProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatPage.prototype, "selectedKnowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatPage.prototype, "fullKnowledgeIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatPage.prototype, "webSearchEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatPage.prototype, "deepSearchEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatPage.prototype, "fullscan", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatPage.prototype, "hasBackdrop", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatPage.prototype, "canTalk", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ChatPage.prototype, "chatHeight", void 0);
exports.ChatPage = ChatPage = ChatPage_1 = __decorate([
    (0, client_1.RWSView)('ai-chat', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(2, (0, client_1.RWSInject)(ChatStateService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object, typeof (_c = typeof ChatStateService_1.ChatStateServiceInstance !== "undefined" && ChatStateService_1.ChatStateServiceInstance) === "function" ? _c : Object])
], ChatPage);
ChatPage.defineComponent();
